/* ════════════════════════════════════════════════════════════════════════════
   ZEUS SURF - COMPONENTS JS
   Interactions: FAQ Accordion, Smooth scroll
   Version: 1.0.0
   ════════════════════════════════════════════════════════════════════════════ */

(function () {
  "use strict";

  /* ──────────────────────────────────────────────────────────────────────────
     FAQ ACCORDION
     ────────────────────────────────────────────────────────────────────────── */

  function initFaqAccordion() {
    document.querySelectorAll("[data-zeus-faq], .zeus-faq").forEach(function (faqContainer) {
      faqContainer.querySelectorAll(".zeus-faq-question").forEach(function (button) {
        const item = button.closest(".zeus-faq-item");

        if (!item) {
          return;
        }

        button.setAttribute("aria-expanded", item.classList.contains("active") ? "true" : "false");

        button.addEventListener("click", function () {
          const isActive = item.classList.contains("active");

          faqContainer.querySelectorAll(".zeus-faq-item").forEach(function (faqItem) {
            faqItem.classList.remove("active");
            const faqButton = faqItem.querySelector(".zeus-faq-question");
            if (faqButton) {
              faqButton.setAttribute("aria-expanded", "false");
            }
          });

          if (!isActive) {
            item.classList.add("active");
            button.setAttribute("aria-expanded", "true");
          }
        });
      });
    });
  }

  /* ──────────────────────────────────────────────────────────────────────────
     SMOOTH SCROLL
     ────────────────────────────────────────────────────────────────────────── */

  function initSmoothScroll() {
    const anchorLinks = document.querySelectorAll('a[href^="#"]');

    anchorLinks.forEach(function (anchor) {
      anchor.addEventListener("click", function (e) {
        const targetId = this.getAttribute("href");

        // Skip if just "#" or empty
        if (targetId === "#" || targetId === "") return;

        const target = document.querySelector(targetId);

        if (target) {
          e.preventDefault();
          const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
          target.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth" });
        }
      });
    });
  }

  /* ──────────────────────────────────────────────────────────────────────────
     NATIVE HORIZONTAL SCROLL CONTROLS
     ────────────────────────────────────────────────────────────────────────── */

  function initNativeScrollControls() {
    document.querySelectorAll("[data-native-scroll-controls]").forEach(function (wrapper) {
      if (wrapper.dataset.nativeScrollInitialized === "true") {
        return;
      }

      var targetId = wrapper.getAttribute("data-native-scroll-controls");
      var target = document.getElementById(targetId);

      if (!target) {
        return;
      }

      var prevBtn = wrapper.querySelector('[data-native-scroll-direction="prev"]');
      var nextBtn = wrapper.querySelector('[data-native-scroll-direction="next"]');

      if (!prevBtn || !nextBtn) {
        return;
      }

      wrapper.dataset.nativeScrollInitialized = "true";

      function prefersReducedMotion() {
        return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      }

      function getScrollStep() {
        var child = target.firstElementChild;

        if (!child) {
          return Math.max(target.clientWidth * 0.8, 1);
        }

        var gap = parseInt(window.getComputedStyle(target).gap, 10) || 0;
        return child.offsetWidth + gap;
      }

      function updateButtons() {
        var maxScroll = target.scrollWidth - target.clientWidth;
        prevBtn.disabled = target.scrollLeft <= 10;
        nextBtn.disabled = maxScroll <= 10 || target.scrollLeft >= maxScroll - 10;
      }

      prevBtn.addEventListener("click", function () {
        target.scrollBy({ left: -getScrollStep(), behavior: prefersReducedMotion() ? "auto" : "smooth" });
      });

      nextBtn.addEventListener("click", function () {
        target.scrollBy({ left: getScrollStep(), behavior: prefersReducedMotion() ? "auto" : "smooth" });
      });

      target.addEventListener("scroll", updateButtons, { passive: true });
      window.addEventListener("resize", updateButtons, { passive: true });
      updateButtons();

      if (!target.hasAttribute("tabindex")) {
        target.setAttribute("tabindex", "0");
      }

      target.addEventListener("keydown", function (event) {
        if (target.scrollWidth <= target.clientWidth) {
          return;
        }

        var behavior = prefersReducedMotion() ? "auto" : "smooth";

        switch (event.key) {
          case "ArrowLeft":
            event.preventDefault();
            target.scrollBy({ left: -getScrollStep(), behavior: behavior });
            break;
          case "ArrowRight":
            event.preventDefault();
            target.scrollBy({ left: getScrollStep(), behavior: behavior });
            break;
          case "Home":
            event.preventDefault();
            target.scrollTo({ left: 0, behavior: behavior });
            break;
          case "End":
            event.preventDefault();
            target.scrollTo({ left: target.scrollWidth, behavior: behavior });
            break;
        }
      });
    });
  }

  function initHomepageOrder() {
    if (!document.body.classList.contains("template-index")) {
      return;
    }

    if (window.Shopify && window.Shopify.designMode) {
      return;
    }

    var main = document.getElementById("main");
    if (!main) {
      return;
    }

    var desktopOrder = [
      "zeus_hero_video_home",
      "zeus_home_products_grid_fzzQHh",
      "zeus_stacking_cards_home",
      "zeus_ecosystem_home",
      "zeus_team_riders_home",
      "zeus_releases_deck_Uyw8Jf",
      "zeus_explore_lineup_rUibXx",
      "zeus_blog_posts_home",
      "zeus_find_dealer_cta_EHBzie",
    ];
    var mobileOrder = [
      "zeus_hero_video_home",
      "zeus_explore_lineup_rUibXx",
      "zeus_home_products_grid_fzzQHh",
      "zeus_find_dealer_cta_EHBzie",
      "zeus_stacking_cards_home",
      "zeus_ecosystem_home",
      "zeus_releases_deck_Uyw8Jf",
      "zeus_team_riders_home",
      "zeus_blog_posts_home",
    ];
    var sections = {};

    for (var i = 0; i < desktopOrder.length; i += 1) {
      var sectionId = desktopOrder[i];
      var sectionNode = main.querySelector('[id$="__' + sectionId + '"]');

      if (!sectionNode) {
        return;
      }

      sections[sectionId] = sectionNode;
    }

    var trailingAnchor = sections[desktopOrder[desktopOrder.length - 1]].nextElementSibling;
    var mobileQuery = window.matchMedia("(max-width: 699px)");

    function applyHomepageOrder() {
      var order = mobileQuery.matches ? mobileOrder : desktopOrder;

      for (var index = 0; index < order.length; index += 1) {
        main.insertBefore(sections[order[index]], trailingAnchor);
      }
    }

    applyHomepageOrder();

    if (typeof mobileQuery.addEventListener === "function") {
      mobileQuery.addEventListener("change", applyHomepageOrder);
    } else if (typeof mobileQuery.addListener === "function") {
      mobileQuery.addListener(applyHomepageOrder);
    }
  }

  /* ──────────────────────────────────────────────────────────────────────────
     INITIALIZATION
     ────────────────────────────────────────────────────────────────────────── */

  function init() {
    // Initialize FAQ accordion
    initFaqAccordion();

    // Initialize smooth scroll
    initSmoothScroll();

    // Native scroll controls for Zeus horizontal lists
    initNativeScrollControls();

    // Preserve the desktop template sequence while prioritizing discovery on mobile
    initHomepageOrder();
  }

  document.addEventListener("shopify:section:load", initNativeScrollControls);

  // Run when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
